import { NormalizedCacheObject } from '@apollo/client';
import { ApolloClient } from '@apollo/client';
import { loader } from 'graphql.macro';
import { Nullable } from 'common-types';
import { logger } from 'logging-utils';
import {
  BirthCertificate,
  GenerateBirthCertificateInput,
} from '../../birth-certificate-types';

const query = loader('./generate-pbom-legacy.gql');

const generateBirthCertificate = (
  client: ApolloClient<NormalizedCacheObject>,
) => {
  return {
    execute: async (
      input: GenerateBirthCertificateInput,
    ): Promise<Nullable<BirthCertificate>> => {
      try {
        const results = await client.query<GenerateBirthCertificateQuery>({
          query,
          variables: { input },
        });

        if (
          !results.data ||
          (!results.data.generateBirthCertificate.json &&
            !results.data.generateBirthCertificate.pdfBuffer &&
            !results.data.generateBirthCertificate.html)
        ) {
          return null;
        }

        return results.data.generateBirthCertificate;
      } catch (error) {
        logger.error(
          `failed to generate PBOM for app: ${input.appId} error:`,
          error,
        );
        return null;
      }
    },
  };
};

interface GenerateBirthCertificateQuery {
  generateBirthCertificate: BirthCertificate;
}

export default generateBirthCertificate;
